import * as React from 'react';
import { SVGProps } from 'react';

const SvgCadRooms = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.09 5.033 7.81 9.835l8.28 4.802 8.278-4.802-8.279-4.802ZM25.625 21.775l-.02-9.571-8.298 4.768.02 9.571 8.298-4.768ZM6.375 21.775l.02-9.571 8.298 4.768-.02 9.571-8.298-4.768Z'
      stroke='#000'
      strokeWidth={0.75}
      strokeLinejoin='round'
    />
  </svg>
);

export default SvgCadRooms;
